export const templateWidget = `
<style>
    @import url("https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700;900&display=swap");
  *, ::after, ::before { box-sizing: border-box; }
  :host { display:block;--width: 27rem; --h_min: 300px; font-family: 'Lato', sans-serif; }
  body { background-image: linear-gradient(to bottom right, #f8fafc, #e0e7ff); font-family: 'Lato', sans-serif; font-size: 18px; min-height: 100vh; }
  body * { font-family: 'Lato', sans-serif; transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); }
  .bg-white { background: #fff; }
  .hidden { display: none; }
  .overflow-hidden { overflow: hidden; }
  .text-center { text-align: center; }
  @keyframes slideUp { to { opacity: 1; transform: translateY(0); } }
  @keyframes float { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-5px); } }
  #chatWidget {z-index:999; background: #fff; border: 1px solid rgb(255 255 255 / 0.2); border-radius: 1.5rem; bottom: 100px; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25); height: 70vh; min-height: 300px; position: fixed; right: 15px; width: var(--width); }
  .chat-widget { z-index:99; background: #fff; animation: slideUp 0.4s ease-out forwards; backdrop-filter: blur(10px); box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25); opacity: 0; transform: translateY(20px); }
  #selectionPopup { bottom: 7rem; position: fixed; right: 2rem; z-index: 50; }
  .chat-widget.selection-popup { z-index:99; align-items: center; animation: slideUp 0.4s ease-out forwards; backdrop-filter: blur(10px); background: #fff; border-radius: 1.5rem; box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.15); display: flex; flex-direction: column; height: 266px; overflow: hidden; width: 320px; }
  .title { color: #000; font-size: 20px; font-style: normal; font-weight: 600; letter-spacing: -0.6px; line-height: 94%; text-align: center; }
  .subtitle { color: #2C2C2C; font-size: 12px; font-style: normal; font-weight: 500; letter-spacing: -0.12px; line-height: normal; margin-top: -13px; }
  .label { color: #2C2C2C; font-size: 12px; font-style: normal; font-weight: 500; letter-spacing: -0.1px; line-height: 130.083%; text-align: center; }
  .desc { margin-top: -10px; color: #000; font-size: 18px; font-style: normal; font-weight: 600; letter-spacing: -0.6px; line-height: 94%; text-align: center; }
  .button-group { display: flex; margin-top: 10px; flex-direction: row; gap: 10px; justify-content: center; width: 100%; }
  .mode-btn { align-items: center; background: #fff; border: none; border-radius: 1.25rem; box-shadow: 0px 0px 20.8px 0px #00000014; 
 color: #18181b; cursor: pointer; display: flex; flex-direction: column; height: 167px; justify-content: flex-start; min-width: 139px; padding: 18px;  transform-origin: 50% 50%;
  will-change: transform;
  animation: cardPulse 2.2s ease-in-out infinite; }
  .mode-btn.text-mode { animation-delay: 0s; }

.mode-btn.voice-mode { animation-delay: -1.1s; }

.mode-btn:hover { box-shadow: 0 4px 24px rgba(31,38,135,0.13); }

@keyframes cardPulse {
  0%   { transform: scale(0.98); }
  50%  { transform: scale(1.035); }
  100% { transform: scale(0.98); }
}
  .mode-btn:hover { box-shadow: 0 4px 24px 0 rgba(31, 38, 135, 0.13); transform: translateY(-2px) scale(1.03); }
  
  .icon { height: 3.2rem; stroke: #7908FB; width: 3.2rem; }
  .text-box { text-align: center; }
  #floatingBtn { bottom: 15px;  position: fixed; right: 15px; }
  .floating-btn {     cursor: pointer; align-items: center; animation: float 3s ease-in-out infinite; background: #FC0E3F; border: 0; border-radius: 9999px; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25); color: #fff; display: flex; filter: brightness(1.15); font-weight: 500; overflow: hidden; padding: 1.25rem; transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); }
  .floating-btn:hover { filter: brightness(1); }
  .floating-btn svg { color: #fff; width: 1.7rem; }
  @media screen and (max-width: 800px) { :host { --width: 21em; } }
  .chat-icon-wrap {
  display: inline-block;
}

.chat-icon {
  display: block;
  height: auto;
}
#chat-icon-color {
  transform-origin: 50% 85%;
  animation: bubble-pop 900ms ease-out both;
  animation-delay: 150ms;
}

@keyframes bubble-pop {
  0%   { transform: scale(0.9); }
  50%  { transform: scale(1);}
  100% { transform: scale(1); }
}

.chat-icon rect {
  transform-box: fill-box; 
  transform-origin: 50% 100%; 
  animation: bar-bounce 2s ease-in-out infinite;
}

.chat-icon rect:nth-of-type(1) { animation-delay: 0ms;    }
.chat-icon rect:nth-of-type(2) { animation-delay: 100ms;  }
.chat-icon rect:nth-of-type(3) { animation-delay: 200ms;  }
.chat-icon rect:nth-of-type(4) { animation-delay: 300ms;  }
.chat-icon rect:nth-of-type(5) { animation-delay: 400ms;  }
.chat-icon rect:nth-of-type(6) { animation-delay: 500ms;  }
.chat-icon rect:nth-of-type(7) { animation-delay: 600ms;  }

.chat-icon rect:nth-of-type(odd)  { animation-duration: 1.05s; }
.chat-icon rect:nth-of-type(even) { animation-duration: 1.25s; }

@keyframes bar-bounce {
  0%   { transform: scaleY(0.45); opacity: 0.85; }
  25%  { transform: scaleY(1.00); opacity: 1; }
  50%  { transform: scaleY(0.6);  opacity: 0.9; }
  75%  { transform: scaleY(1.15); opacity: 1; }
  100% { transform: scaleY(0.45); opacity: 0.85; }
}




.voice-icon {
  display: block;
  width: auto;
  height: auto;
  animation: vi-float 3.5s ease-in-out infinite;
}

@keyframes vi-float {
  0%,100% { transform: translateY(0) }
  50%     { transform: translateY(-2px) }
}

#voice-icon-color {
  transform-origin: 50% 85%;
  animation: vi-pop 900ms ease-out both, vi-glow 2.4s ease-in-out 600ms infinite;
}

@keyframes vi-pop {
  0%   { transform: scale(1) }
  55%  { transform: scale(1) }
  100% { transform: scale(1) }
}
@keyframes vi-glow {
  0%,100%
  50% 
}

.voice-icon path:nth-of-type(1), .voice-icon path:nth-of-type(4)  {
  transform-box: fill-box;
  transform-origin: 50% 50%;
  animation: vi-pulse 1.2s ease-in-out 250ms infinite;
}

@keyframes vi-pulse {
  0%,100% { transform: scale(0.8); }
  50%     { transform: scale(1.1);}
}

.voice-icon path:nth-of-type(7),
.voice-icon path:nth-of-type(9) {
  transform-box: fill-box;
  transform-origin: 50% 50%;
  animation: vi-wave 1.6s ease-in-out infinite;
}

.voice-icon path:nth-of-type(9) {
  animation-delay: 150ms;
}

@keyframes vi-wave {
  0%,100% { transform: scale(1,1);   opacity: .95; }
  50%     { transform: scale(1.08,1.08); opacity: 1; }
}

.voice-icon path:nth-of-type(8) {
  stroke-dasharray: 3 6;
  stroke-dashoffset: 0;
  animation: vi-shimmer 2.2s linear infinite;
}

@keyframes vi-shimmer {
  to { stroke-dashoffset: -18; }
}

.voice-icon rect {
  transform-box: fill-box;
  transform-origin: 50% 50%;
  animation: vi-base-in 700ms cubic-bezier(.2,.8,.2,1) 200ms both;
}

@keyframes vi-base-in {
  0%   { transform: translateY(6px) scaleY(.85); opacity: 0 }
  100% { transform: translateY(0)   scaleY(1);   opacity: 1 }
}

@media (prefers-reduced-motion: reduce) {
  .voice-icon, .voice-icon * { animation: none !important; }
}


</style>

<!-- Chat Widget Box -->
<div id="chatWidget" class="chat-widget hidden ">
    <witzo-chat-element></witzo-chat-element>
    <witzo-voice-element></witzo-voice-element>
</div>

<!-- Selection Popup -->
<div id="selectionPopup" class="fixed bottom-28 right-8 z-50 hidden ">
    <div class="chat-widget selection-popup">
        <div class="text-center ">
        <h3 class="title">Type or Talk. Your choice.</h3>
        <p class="subtitle">Choose how to interact with AI Agent.</p>
        </div>

        <div class="button-group" >
            <button id="selectTextChat" class="mode-btn text-mode">
                <div class="icon-box chat-icon-wrap"> 
                    <svg class="chat-icon" width="82" height="77" viewBox="0 0 82 77" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path id="chat-icon-color" d="M40.897 75.265C40.8974 76.7486 42.6409 77.5449 43.7632 76.5746L63.187 59.7719L70.7856 53.1967L70.8657 53.1302C71.309 52.7696 71.7391 52.3943 72.1616 52.0092L72.2583 51.9222C74.4412 49.8941 76.3195 47.5506 77.8198 44.9515C80.3803 40.5276 81.8452 35.3819 81.8452 29.8861C81.8452 28.1419 81.6967 26.4281 81.4126 24.7679C80.8027 21.192 79.5655 17.8359 77.8159 14.8168C72.6877 5.95521 63.1726 0.000368318 52.2827 0.00036927L29.5669 0.000371256C18.6738 0.000784195 9.15867 5.95512 4.03076 14.8168C1.47029 19.2407 0.000570152 24.3904 0.000484162 29.8861C0.000516005 35.3816 1.46662 40.5278 4.02685 44.9515C9.15474 53.8168 18.6737 59.7714 29.5669 59.7719L39.1645 59.7719C40.1213 59.7719 40.8966 60.5476 40.897 61.5043L40.897 75.265ZM42.8687 57.807C42.0839 58.4568 40.8971 57.8973 40.897 56.8783L40.897 46.684C40.8966 45.7273 40.1213 44.9515 39.1645 44.9515L29.0894 44.9515C28.7085 44.948 28.2951 44.9338 27.8589 44.8988C27.4309 44.8639 27.0292 44.8116 26.6597 44.7523C26.6584 44.7516 26.6568 44.7499 26.6567 44.7484C26.6564 44.7467 26.6546 44.7448 26.6528 44.7445C19.5798 43.5726 14.1832 37.3699 14.1831 29.8861C14.1833 22.4013 19.5816 16.187 26.6597 15.0131C27.4494 14.88 28.2616 14.8168 29.0894 14.8168L52.3745 14.8168L52.3765 14.8148L52.3784 14.8138C60.6099 14.8149 67.2823 21.5605 67.2827 29.8822C67.2827 32.1513 66.6128 34.3657 66.6001 34.4076C65.6612 37.3951 63.9947 39.3779 63.021 40.3763L61.7349 41.4867L61.7075 41.5082L58.1733 44.5658L42.8687 57.807Z" fill="#FC0E3F"/>
                        <rect x="45.3926" y="24.8059" width="2.16696" height="11.9183" rx="1.08348" fill="#01091A"/>
                        <rect x="29.1406" y="25.8896" width="2.16696" height="9.75134" rx="1.08348" fill="#01091A"/>
                        <rect x="39.9756" y="23.7224" width="2.16696" height="14.0853" rx="1.08348" fill="#01091A"/>
                        <rect x="56.2275" y="28.0564" width="2.16696" height="6.50089" rx="1.08348" fill="#01091A"/>
                        <rect x="23.7227" y="28.0564" width="2.16696" height="6.50089" rx="1.08348" fill="#01091A"/>
                        <rect x="50.8096" y="25.8896" width="2.16696" height="9.75134" rx="1.08348" fill="#01091A"/>
                        <rect x="34.5586" y="24.8059" width="2.16696" height="11.9183" rx="1.08348" fill="#01091A"/>
                    </svg>

                </div>
                <div class="text-box">
                <h4 class="label">Don't be shy.</h4>
                <p class="desc">Type Hi!</p>
                </div>
            </button>

            <button id="selectVoiceChat" class="mode-btn voice-mode">
                <div class="icon-box">
                    <svg class="voice-icon" width="82" height="77" viewBox="0 0 101 84" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M45.3379 48.0508C45.3379 51.7468 42.3751 54.7385 38.719 54.7385C35.0629 54.7385 32.1036 51.7468 32.1036 48.0508C32.1036 44.3548 35.0664 41.3631 38.719 41.3631C42.3715 41.3631 45.3379 44.3583 45.3379 48.0508Z" fill="#01091A"/>
                        <path d="M50.5716 19.8188C50.5716 19.8188 50.5539 19.808 50.5432 19.808" stroke="#01091A" stroke-width="0.472263" stroke-miterlimit="10"/>
                        <path d="M50.5716 19.8198C50.5716 19.8198 50.5503 19.827 50.5432 19.8341" stroke="#01091A" stroke-width="0.472263" stroke-miterlimit="10"/>
                        <path d="M69.0535 48.3884C68.874 51.9173 65.9815 54.7275 62.4451 54.7275C58.9087 54.7275 55.8262 51.7323 55.8262 48.0398C55.8262 44.3473 58.789 41.3485 62.4451 41.3485C66.1012 41.3485 69.0218 44.3046 69.0605 47.9651" fill="#01091A"/>
                        <path d="M50.5432 32.547V32.5434H50.5716L50.5432 32.547Z" fill="url(#paint0_linear_983_309)"/>
                        <path id="voice-icon-color" d="M50.5435 1.76176C50.5437 0.254777 52.3149 -0.554325 53.4546 0.431678L73.1802 17.4961L80.897 24.1729L80.9781 24.2403C81.4281 24.6064 81.8655 24.9879 82.2945 25.3789L82.3921 25.4678C84.6086 27.5273 86.5171 29.9078 88.0406 32.5469C90.6405 37.0395 92.1294 42.2659 92.1294 47.8467C92.1294 49.6179 91.9775 51.3581 91.689 53.044C91.0696 56.6757 89.8136 60.0842 88.0367 63.1504C82.8289 72.1498 73.166 78.1968 62.107 78.1973H39.0367C27.974 78.1972 18.311 72.1497 13.1031 63.1504C10.5028 58.6578 9.01144 53.4278 9.01128 47.8467C9.0113 42.2655 10.4999 37.0397 13.1001 32.5469C18.308 23.5436 27.9737 17.4963 39.0367 17.4961H48.7837C49.7548 17.4957 50.543 16.7075 50.5435 15.7364V1.76176ZM52.5455 19.4912C51.7485 18.831 50.5435 19.3995 50.5435 20.4346V30.7871C50.543 31.7583 49.7549 32.5464 48.7837 32.5469H38.5513C38.1645 32.5505 37.7453 32.5651 37.3023 32.6006C36.8676 32.6361 36.4599 32.6889 36.0845 32.7491C36.0827 32.7494 36.0817 32.7511 36.0816 32.753C36.0812 32.7547 36.0793 32.7573 36.0777 32.7579C28.8941 33.9475 23.4137 40.2461 23.4136 47.8467C23.4141 55.4482 28.8959 61.7595 36.0845 62.9512C36.8865 63.0863 37.7107 63.1504 38.5513 63.1504H62.1998L62.2037 63.1543C70.5627 63.1527 77.3388 56.3013 77.3394 47.8506C77.3394 45.5534 76.663 43.31 76.646 43.2539C75.6927 40.2207 74.0001 38.2065 73.0113 37.1924L71.7056 36.0655L71.6773 36.044L68.0884 32.9385L52.5455 19.4912Z" fill="#FC0E3F"/>
                        <path d="M8.91922 37.5695C3.99339 37.6604 0.0739493 41.7273 0.164912 46.6532L0.25475 51.5181C0.345712 56.4439 4.41263 60.3634 9.33846 60.2724C6.19887 51.197 6.2141 46.256 8.91922 37.5695Z" fill="#01091A"/>
                        <path d="M95.31 56.0014C94.6049 63.3108 83.9632 84.9544 53.0982 81.7431" stroke="#01091A" stroke-width="0.810957" stroke-linecap="round"/>
                        <path d="M92.0808 37.5605C97.0064 37.6618 100.917 41.7369 100.816 46.6625L100.716 51.5272C100.615 56.4529 96.5397 60.3638 91.6141 60.2626C94.7726 51.1938 94.7677 46.2527 92.0808 37.5605Z" fill="#01091A"/>
                        <rect x="44.8122" y="79.8205" width="10.5424" height="4.05479" rx="2.02739" fill="#01091A"/>
                        <defs>
                        <linearGradient id="paint0_linear_983_309" x1="50.5432" y1="32.5434" x2="50.5716" y2="32.5434" gradientUnits="userSpaceOnUse">
                        <stop offset="0.07" stop-color="#C1282D"/>
                        <stop offset="0.25" stop-color="#F79421"/>
                        <stop offset="0.43" stop-color="#FAED24"/>
                        <stop offset="0.63" stop-color="#3DB54A"/>
                        <stop offset="0.79" stop-color="#2BAAE2"/>
                        <stop offset="1" stop-color="#67308F"/>
                        </linearGradient>
                        </defs>
                    </svg>

                </div>
                <div class="text-box">
                <h4 class="label">Prefer to talk?</h4>
                <p class="desc">Say Hey!</p>
                </div>
            </button>
        </div>
    </div>
</div>

<!-- Floating Chat Button -->
<div id="floatingBtn" class="floating">
    <button class="floating-btn" id="floating-btn">
    <svg width="32" height="26" viewBox="0 0 32 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.375 6.3125C0.375 3.27493 2.83743 0.8125 5.875 0.8125H25.8125C28.8501 0.8125 31.3125 3.27493 31.3125 6.3125V15.1743L27.5114 13.7677C27.411 13.7306 27.3319 13.6515 27.2948 13.5511L25.4689 8.6168C25.3507 8.29761 24.8993 8.29761 24.7811 8.6168L22.9552 13.5511C22.9181 13.6515 22.839 13.7306 22.7386 13.7677L17.8043 15.5936C17.4851 15.7118 17.4851 16.1632 17.8043 16.2814L22.7386 18.1073C22.839 18.1444 22.9181 18.2235 22.9552 18.3239L24.3618 22.125H18.9339C18.9202 22.1484 18.9049 22.1714 18.888 22.1939L16.3936 25.5174C16.1186 25.8838 15.5689 25.8838 15.2939 25.5174L12.7994 22.1939C12.7826 22.1714 12.7673 22.1484 12.7536 22.125H5.875C2.83743 22.125 0.375 19.6626 0.375 16.625V6.3125ZM19.1094 8.15215C19.0504 7.99255 18.8246 7.99255 18.7656 8.15215L18.4097 9.11387C18.3911 9.16405 18.3516 9.20363 18.3014 9.2222L17.3397 9.57808C17.1801 9.6371 17.1801 9.8629 17.3397 9.92192L18.3014 10.2778C18.3516 10.2964 18.3911 10.3359 18.4097 10.3861L18.7656 11.3478C18.8246 11.5074 19.0504 11.5074 19.1094 11.3478L19.4653 10.3861C19.4839 10.3359 19.5234 10.2964 19.5736 10.2778L20.5353 9.92192C20.6949 9.8629 20.6949 9.6371 20.5353 9.57808L19.5736 9.2222C19.5234 9.20363 19.4839 9.16405 19.4653 9.11387L19.1094 8.15215Z" fill="white"/>
</svg>

    </button>
</div>  

`;
